import React from 'react';
import Home from '../pages/Home.js';
import About from '../pages/About.js';
import Portfolio from '../pages/Portfolio.js';
import Contact from '../pages/Contact.js';
import { AnimatePresence } from 'framer-motion';

//import route, routes and uselocation hook

import {Routes, Route, useLocation } from 'react-router-dom';
const AnimRoutes = () => {
  const location = useLocation();
  return (
    <AnimatePresence initial={true} mode='wait'>
      <Routes key={location.pathname} Location={location}>
      <Route path="/" element={<Home/>}/>
      <Route path="/about" element={<About/>}/>
      <Route path="/portfolio" element={<Portfolio/>}/>
      <Route path="/contact" element={<Contact/>}/> 
    </Routes>
    </AnimatePresence>
  );
  
};

export default AnimRoutes;
